exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".speakerContainer {\n  display: flex;\n  justify-content: flex-start;\n  margin: 10px 0 20px 0; }\n  .speakerContainer .content-decorator {\n    margin-left: 30px; }\n\n.lineContainer .content-decorator {\n  margin-left: 30px; }\n\n.addButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #0067cb; }\n  .addButton p {\n    font-size: 1rem;\n    color: #212529; }\n  .addButton i {\n    font-size: 30px;\n    cursor: pointer; }\n  .addButton.addSpeaker {\n    margin-left: 20px; }\n  .addButton.addLine {\n    justify-content: flex-start;\n    margin-left: 30px;\n    height: 45px; }\n", ""]);

// exports
